import React from 'react';

import { Header } from '../sections/header/header';
import { OptimizedImage } from '../ui/optimized-image/optimized-image';
import clsx from 'clsx';

import floor from 'assets/png/floor.png?format=webp;avif&as=picture';

interface IMobileRoomLayoutProps {
  /** Text shown inside the header */
  title?: React.ReactNode;
  /** React nodes rendered inside the fixed footer (e.g., action buttons) */
  footer: React.ReactNode;
  /** Main page or screen content */
  children: React.ReactNode;
  /** Extra classes for the main scroll area */
  className?: string;
  showFloor?: boolean;
  footerClassNames?: string;
}

const MobileRoomLayout: React.FC<IMobileRoomLayoutProps> = ({
  title = '',
  footer,
  children,
  className = '',
  showFloor = true,
  footerClassNames = '',
}) => (
  <div className="grid max-h-dvh min-h-dvh grid-rows-[auto,1fr,auto]">
    <Header
      className="sticky top-0 z-50 h-20 max-w-screen-2xl px-4 pt-3 lg:mx-auto 2xl:px-0"
      title={title}
    />

    <main
      className={clsx(
        'relative z-10 overflow-y-auto overflow-x-hidden overscroll-contain px-4 text-white sm:pb-40',
        className,
      )}
    >
      {children}
      {showFloor && (
        <OptimizedImage
          imageData={floor}
          alt="floor"
          className="pointer-events-none absolute bottom-0 left-1/2 z-0 min-w-[1120px] -translate-x-1/2 transform select-none"
        />
      )}
    </main>

    <footer
      className={clsx(
        'z-50 flex items-center gap-1.5 overflow-x-auto px-4 pb-1.5 pt-2 sm:h-40',
        footerClassNames || 'border-t border-border bg-[#080540]',
      )}
    >
      {footer}
    </footer>
  </div>
);

export default MobileRoomLayout;
